export const EMPTY_VALUE = "-";

export const gradientClassName =
	"bg-gradient-to-tl from-transparent to-gold/50";

export const forwardClassName = "text-sky-500";

export const BACKGROUND_COLOR = "#000000";
export const TEXT_COLOR = "#c3c3c3";

export const MIN_MAX_COLUMN_CLASSES = "min-w-[8ch] max-w-[10ch] w-[8ch]";
export const MIN_MAX_HEADER_COLUMN_CLASSES =
	"min-w-[10ch] max-w-[12ch] w-[10ch]";

export const COMPONENT_CONTAINER_CLASSES =
	"flex-1 min-w-[42ch] max-w-[53ch] @7xl:min-w-[50ch] w-full m-1";
export const TABLE_WIDTH_SIZES = "min-w-[340px] max-w-[519px]";
